// extracted by mini-css-extract-plugin
export default {"header-container":"i7KL5Owdk_pI_T5cEQRy","header-title":"wvGi3n0jiIJcQZQGTG2Z","header-tooltip-icon":"zCsWXRzqHynUdlAM2g9w"};